export default __webpack_public_path__ + "static/media/Thumb_Shoes_04.d63e0489.png";